















































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, ButtonExport } from '@/components'
import { TableListPermissionControls } from '@/components/dailyControl'

// services
import { PermissionControlsService } from '@/services/dailyControl'
import { EmployeeService, ReasonForPermissionService } from '@/services/config'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// models
import { FiltersPermissionControl, PermissionControlForm, PermissionControlModel } from '@/models/dailyControl'
import { ReasonForPermissionModel, EmployeeModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditPermissionControl from './modalCreateEdit.vue'

const newItem: PermissionControlForm = {
  employee_id: null,
  date_start: '',
  date_end: '',
  reason_id: null,
  observations: ''
}

@Component({
  name: 'PermissionControlsIndex',
  components: {
    PageHeader,
    TableListPermissionControls,
    ModalCreateEditPermissionControl,
    ButtonExport
  }
})
export default class PermissionControlsIndex extends Vue {
  showModal = false
  permissionControl: PermissionControlForm = newItem
  reasons: ReasonForPermissionModel[] = []
  allEmployees: EmployeeModel[] = []
  title = 'Control de Permisos de Empleado'
  actionForm = 'save'
  idItemEdit: number|null = null

  filters: FiltersPermissionControl = {
    dateStart: null,
    dateEnd: null,
    employee: null,
    reason: null
  }

  items = [
    {
      text: 'Dashboard',
      to: { name: 'home' }
    },
    {
      text: 'Control de Permisos de Empleado',
      active: true
    }
  ]

  permissionControls: PermissionControlModel[] = []

  headersExcel = [
    { text: 'Empleado', value: 'employee' },
    { text: 'Motivo', value: 'reason' },
    { text: 'Fecha Inicial', value: 'dateStart' },
    { text: 'Fecha Final', value: 'dateEnd' },
    { text: 'Observaciones', value: 'observations' }
  ]

  get itemsExcel () {
    return this.permissionControls.map(item => {
      return {
        reason: item.reason.description,
        dateStart: item.date_start,
        dateEnd: item.date_end,
        observations: item.observations,
        employee: getFullNameFormat(item.employee)
      }
    })
  }

  created () {
    this.getAll()
  }

  async getAll () {
    this.allEmployees = await EmployeeService.getAll()
    this.reasons = await ReasonForPermissionService.getActivated()
  }

  get employees () {
    return this.allEmployees.filter(item => this.actionForm === 'save' ? item.is_active : item.is_active || item.id === this.permissionControl.employee_id)
  }

  async getAllitems () {
    this.permissionControls = await PermissionControlsService.getAll(this.filters)
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.permissionControl = newItem
    this.showModal = true
  }

  editItem (item: PermissionControlModel) {
    this.permissionControl = {
      employee_id: item.employee.id ?? null,
      date_start: item.date_start,
      date_end: item.date_end,
      reason_id: item.reason_id,
      observations: item.observations
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: PermissionControlModel) {
    const msg = `Seguro que desea eliminar el Control de Permiso del Empleado: ${item.employee.name} ${item.employee.last_name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await PermissionControlsService.delete(item.id)
      alerts.success()
      this.tableList.getPermissionControlsWithPagination()
      loading('hide')
    }
  }

  get tableList (): Vue & { getPermissionControlsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getPermissionControlsWithPagination: () => void }
  }

  get itemInit (): PermissionControlForm {
      return newItem
  }
}
